/* eslint-disable no-console */
import territories from '@plebiscito/plebiscito/contextData/territories'
import { zones } from '@plebiscito/plebiscito/contextData/zonesData'
import { getRegionCommunes } from '@plebiscito/plebiscito/helpers'
import {
  filterTable,
  getAllData,
  getTerritoriesResult,
  sorterHandler as sorterHandlerBase,
} from '@plebiscito/plebiscito/RegionSection/helpers'
import _ from 'lodash'
import styled from 'styled-components'

import Summary from '../RegionSection/Summary'

export const sorterHandler = ({ field, setSorter, sorter }) => {
  const newField = 'order' === field ? 'label' : field
  sorterHandlerBase({ field: newField, setSorter, sorter })
}

export const getTableData = ({
  comparedElection,
  inputFilter,
  pEntrada,
  pSalida,
  regionId,
  sVuelta,
  selectedCommune,
  selectedUnit,
  setSelectedCommune,
  sortTable,
  sorter,
}) => {
  const allElectionsData = getAllData({ pEntrada, pSalida, sVuelta })
  const regionData = getRegionCommunes({ allElectionsData, regionId, zones })

  const communes = _.uniqBy(regionData, 'N_KEY')
  const dataByElection = _.groupBy(regionData, 'electionKey')
  const results = communes.map((commune) => {
    const communeResults = Object.entries(dataByElection)
      .reduce(
        (results, [electionKey, communes]) => {
          const selectedCommune = communes.find((c) => {
            return c.N_KEY === commune.N_KEY
          })
          if (!selectedCommune) {
            console.error('Not found', commune.N_KEY)
            console.error('in', communes)
            results[electionKey] = { ...getTerritoriesResult([communes[0]]), communeData: commune }
            return results
          }
          results[electionKey] = { ...getTerritoriesResult([selectedCommune]), communeData: commune }
          return results
        },
        {}
      )

    const communeName = territories
      .find((territory) => territory.n_key_comuna === commune.N_KEY)
      ?.label.toLowerCase()
    const isCommuneSelected = commune.N_KEY === selectedCommune
    return {
      key: commune.N_KEY.toLowerCase(),
      label: communeName,
      onClick: () => setSelectedCommune(isCommuneSelected ? '' : commune.N_KEY),
      results: communeResults,
      rowItem: (
        <CommuneSummary
          communeKey={commune.N_KEY}
          communeName={communeName}
        />
      ),
    }
  }, {})
  const selectedCommuneData = results.find((t) => t.key === selectedCommune)
  if (selectedCommuneData) {
    selectedCommuneData.selected = true
  }

  const sortedData = sortTable({ data: results, sorter })
  const filteredData = filterTable({
    comparedElection,
    data: sortedData,
    inputFilter,
    selectedUnit,
  })
  return filteredData
}

const CommuneSummary = styled(Summary)`
  padding: 24em;
  border: 2px solid rgb(255, 0, 0);
`
